/******************************************************************************
 * *
 * Feature Toggle
 * Usage: Wrapper enclosing the feature should have if.bind to isFeatureVisible
 * *
 ********************************************************************************/
import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { autoinject, bindable, bindingMode, containerless, customElement, inlineView } from "aurelia-framework";

import Infrastructure from "../../../common/infrastructure";
import { AccountStore, AccountStoreEvents } from "../../../common/stores/account-store";

@customElement("feature-toggle")
@inlineView("<template><slot></slot></template>")
@containerless
@autoinject
export class FeatureToggle {
    @bindable({ defaultBindingMode: bindingMode.fromView })
    public isFeatureVisible: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public feature: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public isHiding: boolean = false;
    private _ea: EventAggregator;
    private _accountStoreSubscription: Subscription;
    public element: Element;

    public constructor(ea: EventAggregator) {
        this._ea = ea;
    }

    public attached() {
        this.isFeatureVisible = this.checkFeatureVisibility();
        if (!!this.feature) {
            this.initSubscriptions();
        }
    }

    public initSubscriptions() {
        this._ea.subscribe(AccountStoreEvents.Loaded, () => {
            this.isFeatureVisible = this.checkFeatureVisibility();
        });
    }

    private checkFeatureVisibility() {
        let isProd = Infrastructure.isProdEnvironment;
        if (!this.feature || !isProd) {
            return !isProd;
        }
        let hasFeature = AccountStore.featureToggles.some((flag) => flag === this.feature);
        return !(hasFeature == this.isHiding);
    }

    public detached() {
        this._accountStoreSubscription?.dispose();
    }
}
